'use client';

import { ReactNode } from 'react';
import { AskAiProvider } from './ask-ai';

interface AcademyAskAiProps {
  children: ReactNode;
  className?: string;
}

/**
 * Academy Ask AI - Inline panel implementation for Academy pages
 * Features:
 * - Inline panel with subtle sliding animation from right to left
 * - AskAiHeaderButton trigger in main navigation header
 * - Controlled sliding animation timing optimized for Academy layout
 * - Smart integration with Academy's existing navigation and layout
 */
export default function AcademyAskAi({ 
  children, 
  className 
}: AcademyAskAiProps) {
  return (
      <div 
        className={className}
        data-ask-ai-context="academy"
        style={{
          // Academy-specific animation with expand functionality - 300ms timing
          '--academy-panel-transition': 'transform 300ms ease-out, width 300ms ease-out',
        } as React.CSSProperties & Record<string, string>}
      >
      <AskAiProvider
        showFloatingTrigger={false}
        panelPlacement="inline"
        placeholder="Ask a follow up question ..."
      >
        {children}
      </AskAiProvider>
    </div>
  );
}